/*
  作者：liu.jinming
  时间：2018-1-10
  Modyify by cc 19-11-14 兼容新疆播放视频逻辑
  描述：编辑器视频播放外置播放器
*/
'use strict';
angular.module('videoplayerModule', []).controller('videoplayerCtrl', [
    '$scope',
    '$interval',
    '$modalInstance',
    '$timeout',
    'item',
    '$sce',
    'editCenUploadVideoForXjService',
    'mrApiService',
    'modalDialog',
    '$sessionStorage',
    '$state',
    'publicToolService',
    function($scope, $interval, $modalInstance, $timeout, item, $sce, editCenUploadVideoForXjService, mrApiService, modalDialog, $sessionStorage, $state, publicToolService) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.data = {
                type: item.type === 'video' ? '视频' : '音频',
                relationid: item.relationid,
                meiziid: item.meiziid,
                // videoId: item.videoid,
                videoInfo: {},
                fastVideoTimer: '',
                mediaName: '',
                medialists: {
                    'fusionnews': '个人稿库',
                    'fusionvideo': '个人稿库',
                    'newspapertext': '纸媒',
                    'websitenews': '网站',
                    'websitevideo': '网站',
                    'appnews': '客户端',
                    'appvideo': '客户端',
                    'weiboedit': '微博',
                    'trillnews': '抖音',
                    'baijiahaonews': '百家号',
                    'baijiahaovideo': '百家号',
                    'qiehaonews': '企鹅号',
                    'qiehaovideo': '企鹅号',
                    'toutiaohaonews': '头条号',
                    'toutiaohaovideo': '头条号',
                },
                errMsg: null,

            };
            $scope.status = {
                isVideo: item.type === 'video',
                machineStatus: '', // 0 审核中 -1 失败 1 成功
                machineFlag: true,
                timerToStatus: '',
                toolBarDirect: 'left',
                isShowCheckSuccess: false
            };
        }

        /**
         * [initData description]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.data.videoInfo.videoid = item.videoid;
            requestVideoInfo();
            publicToolService.getModeconfiguration('avUploader').then((config) => {
                $scope.status.avUploadrOption = config;
            });
        }

        /**
         * [startInterval description]设置定时器
         * @return {[type]} [description]
         */
        function startInterval() {
            $interval.cancel($scope.data.fastVideoTimer);
            $scope.data.fastVideoTimer = $interval(function() {
                requestVideoInfo();
            }, 1000 * 8);
        }

        /**
         * [requestVideoInfo description]
         *
         * @return  {[type]}  [return description]
         */
        function requestVideoInfo() {
            editCenUploadVideoForXjService.getVideoMark($scope.data.videoInfo.videoid).then(function(data) {
                $timeout(function() {
                    fillVideoInfo(data);
                    if ($scope.data.videoInfo.status === '转码中' || $scope.data.videoInfo.status === '快编中') {
                        if (!$scope.data.fastVideoTimer) {
                            startInterval();
                        }
                    } else {
                        $interval.cancel($scope.data.fastVideoTimer);
                    }
                });
            }, (error) => {
                fillVideoInfo(error);
            });
        }

        /**
         * [fillVideoInfo description]
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        function fillVideoInfo(data) {
            if (data.videoUrl) {
                $scope.data.videoInfo.url = $sce.trustAsResourceUrl(data.videoUrl);
            }
            if (data.videoId) {
                $scope.data.videoInfo.videoid = data.videoId;
            }
            if (data.ThumbImg) {
                $scope.data.videoInfo.thumbImg = data.ThumbImg;
            }
            $scope.data.videoInfo.status = editCenUploadVideoForXjService.videoDraftStatus[data.status];
        }

        /**
         * [close description]
         *
         * @return  {[type]}  [return description]
         */
        $scope.close = function() {
            $interval.cancel($scope.data.fastVideoTimer);
            $modalInstance.dismiss();
        };

        /**
         * [confirm description]
         * @return  {[type]}  [return description]
         */
        $scope.confirm = function() {
            $interval.cancel($scope.data.fastVideoTimer);
            $modalInstance.close({ src: $scope.data.videoInfo.thumbImg, videoid: $scope.data.videoInfo.videoid });
        };

        /**
         * [editVideo description]快编视频
         * @return {[type]} [description]
         */
        $scope.fastEditVideo = function() {
            $scope.loadingPromise = editCenUploadVideoForXjService.editVideo($scope.data.videoInfo.videoid).then(function(data) {
                $scope.data.videoInfo.videoid = data.datas.videoid; // 回写ID
                window.open(data.datas.qediturl); // 打开快编页面
                startInterval();
            });
        };

        /**
         * [cancelEditVideo description]取消快编
         * @return {[type]} [description]
         */
        $scope.cancelEditVideo = function() {
            $scope.loadingPromise = editCenUploadVideoForXjService.cancelEditVideo($scope.data.videoInfo.videoid).then(function(data) {
                $timeout(function() {
                    fillVideoInfo(data);
                });
            });
        };

        /**
         * [initMachineReview description]初始化智能机审
         * @return  {[type]}     [return description]
         */
        function initMachineReview() {
            var relationId = $scope.data.relationid;
            if (!relationId){
                return;
            }
            mrApiService.getMaterialDetail({
                mrType: 'personal',
                mainResourceType: 2,
                relationId: $scope.data.relationid,
            }).then(function(data) {
                $scope.status.machineStatus = data.datas[0].checkstatus;
                $scope.status.machineFlag = true;
                if (data.datas[0].checkstatus == 0){
                    setTimerToStatus();
                } else if (data.datas[0].checkstatus == 1){
                    $timeout.cancel($scope.status.timerToStatus);
                } else {
                    $timeout.cancel($scope.status.timerToStatus);
                    getErrorMsg();
                }

            });
        }

        /**
         * [machineReview description]智能机审
         * @return  {[type]}     [return description]
         */
        $scope.machineReview = function() {
            $scope.status.machineStatus = 0;
            getMRresult();
        };

        /**
         * [getMRresult description]智能机审
         * @return  {[type]}     [return description]
         */
        function getMRresult() {
            if (!$scope.data.relationid) {
                return;
            }
            mrApiService
                .requestCensor({
                    mrType: 'personal',
                    mainResourceType: 2,
                    relationId: $scope.data.relationid,
                }).then(function(data) {
                    if (data.code == 200) {
                        setTimerToStatus();
                    } else {
                        modalDialog.alertType('', data.msg, 'error', false);
                    }
                });
        }

        /**
         * [setTimerToStatus description] 定时器查询机审状态
         * @return  {[type]}     [return description]
         */
        function setTimerToStatus() {
            $timeout.cancel($scope.status.timerToStatus);
            $scope.status.machineFlag = false;
            $scope.status.timerToStatus = $timeout(function() {
                initMachineReview();
            }, editCenUploadVideoForXjService.videoPollInterval);
        }

        /**
         * [requestData description] 回调刷新数据
         * @return  {[type]}     [return description]
         */
        $scope.requestData = function() {
            $scope.status.machineFlag = true;
        };

        /**
         * [getErrorMsg description] 审核不通过获取错误信息
         * @return  {[type]}     [return description]
         */
        function getErrorMsg() {
            var param = {
                resourceid: $scope.data.meiziid,
                tenantId: $sessionStorage.get('curUserInfo').TENANTID,
                userName: $sessionStorage.get('curUserInfo').USERNAME,
            };
            mrApiService.getErrorMsg(param).then(function(data) {
                if (data.code === '200') {
                    $scope.status.errMsg = data.datas;
                    $scope.data.mediaName = $scope.data.medialists[$state.current.name];
                }
            });
        }
    },
]);
